// import  { useState,useEffect , useRef} from "react";
// import { FaPlus, FaThLarge } from "react-icons/fa";
// import { useNavigate,useLocation } from "react-router-dom";
// import { MdGridView } from "react-icons/md";
// import axios from "axios";
// import {
//   showSuccess,
//   showError,
// } from "../../General/Toast";


// const Category = ({clientData}) => {
//   const [inventory, setInventory] = useState([]);
// const [filteredItems, setFilteredItems] = useState([]);
//   const filterRef = useRef(null);
//   const [showCategoryModal, setShowCategoryModal] = useState(false);
// const [categoryName, setCategoryName] = useState("");
//     const navigate = useNavigate();
//     const [selectedCategory, setSelectedCategory] = useState("");
//       const location = useLocation();
//         const [showPartyForm, setShowPartyForm] = useState(false);
//         const [showFilter, setShowFilter] = useState(false);
//         const [filterType, setFilterType] = useState("Products");
//         // const client_id = localStorage.getItem("client_id");

// const [categories, setCategories] = useState([]);
// const [loading, setLoading] = useState(false);
// const client_id=clientData.id;

// useEffect(() => {
//   const handleClickOutside = (event) => {
//     if (
//       filterRef.current &&
//       !filterRef.current.contains(event.target)
//     ) {
//       setShowFilter(false);
//     }
//   };

//   document.addEventListener("mousedown", handleClickOutside);

//   return () => {
//     document.removeEventListener(
//       "mousedown",
//       handleClickOutside
//     );
//   };
// }, []);


//   const items = [
//     {
//       name:"PAYMENT",
//       stock:0,
//       pp:"₹0.00",
//       sp:"₹0.00",
//       sold:0
//     }
//   ];
//   const fetchInventory = async () => {
//   try {
//     const res = await axios.get(
//       `https://api.dectwinbilling.com/fetch-inventory/${client_id}`
//     );

//     setInventory(res.data);
//     setFilteredItems(res.data);
//   } catch (error) {
//     console.log(error);
//   }
// };

// useEffect(() => {
//   fetchCategories();
//   fetchInventory();
// }, []);
// //   const fetchCategories = async () => {
// //   try {
// //     const response = await axios.get(
// //       `https://api.dectwinbilling.com/fetch-category/${client_id}`
// //     );

// //     setCategories(response.data);

// //     if (response.data.length > 0) {
// //       setSelectedCategory(response.data[0].cat_name);
// //     }
// //   } catch (error) {
// //     console.log(error);
// //   }
// // };
// const fetchCategories = async () => {
//   try {
//     const response = await axios.get(
//       `https://api.dectwinbilling.com/fetch-category/${client_id}`
//     );

//     setCategories(response.data);

//     if (response.data.length > 0) {
//       const firstCategory = response.data[0].cat_name;

//       setSelectedCategory(firstCategory);

//       const filtered = inventory.filter(
//         (item) => item.category === firstCategory
//       );

//       setFilteredItems(filtered);
//     }
//   } catch (error) {
//     console.log(error);
//   }
// };
// const handleAddCategory = async () => {
//   if (!categoryName.trim()) {
//      showSuccess("Please enter category name");
//     return;
//   }

//   try {
//     setLoading(true);

//     const response = await axios.post(
//       "https://api.dectwinbilling.com/add-category",
//       {
//         cat_name: categoryName,
//         cat_type: "Category",
//         client_id,
//       }
//     );

//     showSuccess("Category add successfully");

  
//   await fetchCategories();

//     setSelectedCategory(categoryName);
//     setCategoryName("");
//     setShowCategoryModal(false);

//   } catch (error) {
//       showError(
//       error.response?.data?.message ||
//       "Something went wrong"
//     );
//   } finally {
//     setLoading(false);
//   }
// };
// return (

// <div className="container-fluid min-vh-100 p-3"
// style={{
// background:"#eef1f7"
// }}>



// <div
//   className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-3"
// >


// <h3 className="fw-bold mb-0">
// Categories
// </h3>


// {/* <div className="d-flex gap-3"> */}

// <div
//   className="d-flex gap-2 flex-wrap justify-content-end align-items-center"
// >

// <button
//   className="btn text-white fw-semibold"
//   style={{
//     background: "var(--primary-color)",
//     borderRadius: "12px",
//     boxShadow: "0 5px 15px #ccc",
//     minHeight: "45px"
//   }}
//   onClick={() => setShowCategoryModal(true)}
// >
//   <FaPlus className="me-2" />
//   Add Category
// </button>
// {showCategoryModal && (
//   <div
//     className="modal fade show d-block"
//     style={{ background: "rgba(0,0,0,.5)" }}
//   >
//     <div className="modal-dialog modal-dialog-centered">
//       <div
//         className="modal-content border-0"
//         style={{
//           borderRadius: "20px"
//         }}
//       >
//         <div className="modal-body p-4">

//           <h4 className="fw-bold mb-4">
//             Add Category
//           </h4>

//           <input
//             type="text"
//             className="form-control mb-4"
//             placeholder="Enter Category Name"
//             value={categoryName}
//             onChange={(e) =>
//               setCategoryName(e.target.value)
//             }
//           />

//           <div className="d-flex justify-content-end gap-2">

//             <button
//               className="btn btn-secondary"
//               onClick={() => setShowCategoryModal(false)}
//             >
//               Cancel
//             </button>

//             <button
//               className="btn text-white"
//               style={{
//                 background: "var(--primary-color)"
//               }}
//               onClick={handleAddCategory}
//             >
//               Add
//             </button>

//           </div>

//         </div>
//       </div>
//     </div>
//   </div>
// )}

//   {/* <button
//     className="grid-btn"
//     onClick={() => setShowFilter(!showFilter)}
//   >
//     <MdGridView />
//   </button> */}

//  {/* {showFilter && (
//   <div className="filter-dropdown">

//     <div
//       className={location.pathname === "/items" ? "active-menu" : ""}
//       onClick={() => {
//         setFilterType("product");
//         setShowFilter(false);
//         navigate("/items");
//       }}
//     >
//       Product
//     </div>

//     <div
//       className={location.pathname === "/services" ? "active-menu" : ""}
//       onClick={() => {
//         setFilterType("Services");
//         setShowFilter(false);
//         navigate("/services");
//       }}
//     >
//       Services
//     </div>

//     <div
//       className={location.pathname === "/category" ? "active-menu" : ""}
//       onClick={() => {
//         setFilterType("Categories");
//         setShowFilter(false);
//         navigate("/category");
//       }}
//     >
//       Categories
//     </div>

//     <div
//       className={location.pathname === "/units" ? "active-menu" : ""}
//       onClick={() => {
//         setFilterType("Units");
//         setShowFilter(false);
//         navigate("/units");
//       }}
//     >
//       Units
//     </div>

//   </div>
// )} */}


// <div
//   className="position-relative"
//   ref={filterRef}
//   style={{
//     zIndex: 10000,
//   }}
// >
//   <button
//     className="grid-btn"
//     onClick={() => setShowFilter(!showFilter)}
//   >
//     <MdGridView />
//   </button>

//   {showFilter && (
//     <div
//       style={{
//         position: "absolute",
//         top: "48px",

//         // Mobile & Desktop Responsive
//         right: window.innerWidth <= 576 ? "-10px" : "0",

//         width: window.innerWidth <= 576 ? "120px" : "180px",

//         background: "#fff",
//         borderRadius: "10px",
//         boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
//         zIndex: 99999,
//         overflow: "hidden",
//       }}
//     >
//       <div
//         className={
//           location.pathname === "/items"
//             ? "active-menu"
//             : ""
//         }
//         onClick={() => {
//           setShowFilter(false);
//           navigate("/items");
//         }}
//         style={{
//           padding: "10px 12px",
//           cursor: "pointer",
//           borderBottom: "1px solid #eee",
//           fontSize: "14px",
//         }}
//       >
//         Product
//       </div>

//       <div
//         className={
//           location.pathname === "/services"
//             ? "active-menu"
//             : ""
//         }
//         onClick={() => {
//           setShowFilter(false);
//           navigate("/services");
//         }}
//         style={{
//           padding: "10px 12px",
//           cursor: "pointer",
//           borderBottom: "1px solid #eee",
//           fontSize: "14px",
//         }}
//       >
//         Services
//       </div>

//       <div
//         className={
//           location.pathname === "/category"
//             ? "active-menu"
//             : ""
//         }
//         onClick={() => {
//           setShowFilter(false);
//           navigate("/category");
//         }}
//         style={{
//           padding: "10px 12px",
//           cursor: "pointer",
//           borderBottom: "1px solid #eee",
//           fontSize: "14px",
//         }}
//       >
//         Categories
//       </div>

//       <div
//         className={
//           location.pathname === "/units"
//             ? "active-menu"
//             : ""
//         }
//         onClick={() => {
//           setShowFilter(false);
//           navigate("/units");
//         }}
//         style={{
//           padding: "10px 12px",
//           cursor: "pointer",
//           fontSize: "14px",
//         }}
//       >
//         Units
//       </div>
//     </div>
//   )}
// </div>



// </div>


// </div>





// <div className="row g-4">




// {/* <div className="col-lg-3"> */}
// <div className="col-12 col-md-4 col-lg-3">


// <div
// className="card border-0 shadow h-100"
// style={{
// borderRadius:"20px"
// }}
// >


// <div className="card-body">


// <h5 className="fw-bold text-center mb-3">
// All Categories
// </h5>



// <div
// style={{
// maxHeight:"600px",
// overflowY:"auto"
// }}
// >


// {/* {
//   categories.map((cat) => (
//     <button
//       key={cat.id}
//       onClick={() => setSelectedCategory(cat.cat_name)}
//       className="btn w-100 mb-3 fw-semibold"
//       style={{
//         padding: "12px",
//         borderRadius: "15px",
//         background:
//           selectedCategory === cat.cat_name
//             ? "linear-gradient(135deg,#F96E5B,#F96E5B)"
//             : "#fff",
//         color:
//           selectedCategory === cat.cat_name
//             ? "#fff"
//             : "#333",
//         boxShadow: "0 4px 10px rgba(0,0,0,.15)"
//       }}
//     >
//       {cat.cat_name}
//     </button>
//   ))
// } */}
// {
//   categories.map((cat) => (
//     <button
//       key={cat.id}
//       // onClick={() => setSelectedCategory(cat.cat_name)}
//       onClick={() => {
//   setSelectedCategory(cat.cat_name);

//   const filtered = inventory.filter(
//     (item) => item.category === cat.cat_name
//   );

//   setFilteredItems(filtered);
// }}
//       className="btn w-100 mb-3 fw-semibold"
//       style={{
//         padding: "12px",
//         borderRadius: "15px",
//         background:
//           selectedCategory === cat.cat_name
//             ? "linear-gradient(135deg,#F96E5B,#F96E5B)"
//             : "#fff",
//         color:
//           selectedCategory === cat.cat_name
//             ? "#fff"
//             : "#333",
//         boxShadow: "0 4px 10px rgba(0,0,0,.15)"
//       }}
//     >
//       {cat.cat_name}
//     </button>
//   ))
// }



// </div>


// </div>


// </div>


// </div>






// {/* <div className="col-lg-9"> */}
// <div className="col-12 col-md-8 col-lg-9">


// <div
// className="card border-0 shadow"
// style={{
// borderRadius:"20px"
// }}
// >


// <div className="card-body">


// <div className="d-flex justify-content-between align-items-center mb-3">


// <h5 className="fw-bold mb-0">
//   Category : {selectedCategory || "No Category"}
// </h5>


// <span
// className="badge px-3 py-2"
// style={{
// background:"var(--primary-color)",
// fontSize:"14px"
// }}
// >
// Total Items : {filteredItems.length}
// </span>


// </div>





// <div className="table-responsive">


// <table
// className="table align-middle text-center"
// >


// <thead
// style={{
// background:"var(--primary-color)",
// color:"#fff"
// }}
// >

// <tr>

// <th>Item Name</th>
// <th>Stock</th>
// <th>Total PP(₹)</th>
// <th>Total SP(₹)</th>
// <th>Sold</th>

// </tr>

// </thead>



// <tbody>
//   {filteredItems.length > 0 ? (
//     filteredItems.map((item, index) => (
//       <tr key={index}>
//         <td className="fw-semibold">
//           {item.name}
//         </td>

//         <td>
//           {item.stock}
//         </td>

//         <td>
//           ₹{item.pur_price}
//         </td>

//         <td>
//           ₹{item.sale_price}
//         </td>

//         <td>
//           0
//         </td>
//       </tr>
//     ))
//   ) : (
//     <tr>
//       <td colSpan="5" className="text-center">
//         No Items Found
//       </td>
//     </tr>
//   )}
// </tbody>




// <tfoot
// style={{
// background:"var(--primary-color)",
// color:"#fff",
// fontWeight:"700"
// }}
// >

// <tr>

// <td>
// Total
// </td>

// <td>
// 0
// </td>

// <td>
// ₹0.00
// </td>

// <td>
// ₹0.00
// </td>

// <td>
// 0
// </td>

// </tr>

// </tfoot>


// </table>


// </div>



// </div>

// </div>


// </div>


// </div>


// </div>

// )

// }


// export default Category;

import { useState, useEffect, useRef } from "react";
import { FaPlus, FaThLarge } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import { MdGridView } from "react-icons/md";
import axios from "axios";

import {
  showSuccess,
  showError,
} from "../../General/Toast";

const Category = ({ clientData }) => {
  const [inventory, setInventory] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);

  const filterRef = useRef(null);

  const [showCategoryModal, setShowCategoryModal] =
    useState(false);

  const [categoryName, setCategoryName] =
    useState("");

  const navigate = useNavigate();

  const [selectedCategory, setSelectedCategory] =
    useState("");

  const location = useLocation();

  const [showPartyForm, setShowPartyForm] =
    useState(false);

  const [showFilter, setShowFilter] =
    useState(false);

  const [filterType, setFilterType] =
    useState("Products");

  const [categories, setCategories] =
    useState([]);

  const [loading, setLoading] =
    useState(false);

  const client_id = clientData.id;

  /* =====================================================
     CLOSE FILTER WHEN CLICK OUTSIDE
  ===================================================== */

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        filterRef.current &&
        !filterRef.current.contains(event.target)
      ) {
        setShowFilter(false);
      }
    };

    document.addEventListener(
      "mousedown",
      handleClickOutside
    );

    return () => {
      document.removeEventListener(
        "mousedown",
        handleClickOutside
      );
    };
  }, []);

  /* =====================================================
     STATIC ITEMS
  ===================================================== */

  const items = [
    {
      name: "PAYMENT",
      stock: 0,
      pp: "₹0.00",
      sp: "₹0.00",
      sold: 0,
    },
  ];

  /* =====================================================
     FETCH INVENTORY
  ===================================================== */

  const fetchInventory = async () => {
    try {
      const res = await axios.get(
        `https://api.dectwinbilling.com/fetch-inventory/${client_id}`
      );

      setInventory(res.data);
      setFilteredItems(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  /* =====================================================
     FETCH CATEGORIES
  ===================================================== */

  const fetchCategories = async () => {
    try {
      const response = await axios.get(
        `https://api.dectwinbilling.com/fetch-category/${client_id}`
      );

      setCategories(response.data);

      if (response.data.length > 0) {
        const firstCategory =
          response.data[0].cat_name;

        setSelectedCategory(firstCategory);

        const filtered = inventory.filter(
          (item) =>
            item.category === firstCategory
        );

        setFilteredItems(filtered);
      }
    } catch (error) {
      console.log(error);
    }
  };

  /* =====================================================
     INITIAL LOAD
  ===================================================== */

  useEffect(() => {
    fetchCategories();
    fetchInventory();
  }, []);

  /* =====================================================
     ADD CATEGORY
  ===================================================== */

  const handleAddCategory = async () => {
    if (!categoryName.trim()) {
      showSuccess("Please enter category name");
      return;
    }

    try {
      setLoading(true);

      const response = await axios.post(
        "https://api.dectwinbilling.com/add-category",
        {
          cat_name: categoryName,
          cat_type: "Category",
          client_id,
        }
      );

      showSuccess("Category add successfully");

      await fetchCategories();

      setSelectedCategory(categoryName);

      setCategoryName("");

      setShowCategoryModal(false);
    } catch (error) {
      showError(
        error.response?.data?.message ||
          "Something went wrong"
      );
    } finally {
      setLoading(false);
    }
  };

  /* =====================================================
     UI
  ===================================================== */

  return (
    <div
      className="container-fluid min-vh-100 px-2 px-sm-3 py-3"
      style={{
        background: "#eef1f7",
      }}
    >

      {/* =================================================
          HEADER
      ================================================= */}

      <div className="card border-0 shadow-sm rounded-4 mb-3">
        <div className="card-body p-2 p-sm-3 p-md-4">

          <div className="row g-2 align-items-center">

            {/* TITLE */}
            <div className="col-12 col-md">
              <h4 className="fw-bold mb-1">
                Categories
              </h4>

              <small className="text-muted d-block">
                Manage your product categories
              </small>
            </div>

            {/* ACTIONS */}
            <div className="col-12 col-md-auto">
              <div className="d-flex align-items-center gap-2">

                {/* ADD CATEGORY */}
            <button
  type="button"
  className="btn text-white fw-semibold d-inline-flex align-items-center justify-content-center flex-shrink-0"
  style={{
    background: "var(--primary-color)",
    borderRadius: "8px",
    height: "36px",
    width: "115px",
    minWidth: "115px",
    padding: "0 8px",
    fontSize: "11px",
    whiteSpace: "nowrap",
  }}
  onClick={() => setShowCategoryModal(true)}
>
  <FaPlus
    className="me-1"
    size={8}
  />
  Add Category
</button>

                {/* FILTER BUTTON */}
                <div
                  className="position-relative flex-shrink-0"
                  ref={filterRef}
                  style={{
                    zIndex: 10000,
                  }}
                >
                  <button
                    type="button"
                    className="btn btn-light border shadow-sm d-flex align-items-center justify-content-center"
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "10px",
                      padding: 0,
                    }}
                    onClick={() =>
                      setShowFilter(!showFilter)
                    }
                  >
                    <MdGridView size={19} />
                  </button>

                  {/* FILTER DROPDOWN */}
                  {showFilter && (
                    <div
                      className="position-absolute end-0 mt-2 bg-white shadow border overflow-hidden"
                      style={{
                        width: "180px",
                        borderRadius: "12px",
                        zIndex: 99999,
                      }}
                    >

                      {/* PRODUCT */}
                      <div
                        className={`px-3 py-2 ${
                          location.pathname ===
                          "/items"
                            ? "bg-light fw-semibold"
                            : ""
                        }`}
                        style={{
                          cursor: "pointer",
                          fontSize: "14px",
                        }}
                        onClick={() => {
                          setFilterType("product");
                          setShowFilter(false);
                          navigate("/items");
                        }}
                      >
                        Product
                      </div>

                      {/* SERVICES */}
                      <div
                        className={`px-3 py-2 ${
                          location.pathname ===
                          "/services"
                            ? "bg-light fw-semibold"
                            : ""
                        }`}
                        style={{
                          cursor: "pointer",
                          fontSize: "14px",
                        }}
                        onClick={() => {
                          setFilterType("Services");
                          setShowFilter(false);
                          navigate("/services");
                        }}
                      >
                        Services
                      </div>

                      {/* CATEGORIES */}
                      <div
                        className={`px-3 py-2 ${
                          location.pathname ===
                          "/category"
                            ? "bg-light fw-semibold"
                            : ""
                        }`}
                        style={{
                          cursor: "pointer",
                          fontSize: "14px",
                        }}
                        onClick={() => {
                          setFilterType("Categories");
                          setShowFilter(false);
                          navigate("/category");
                        }}
                      >
                        Categories
                      </div>

                      {/* UNITS */}
                      <div
                        className={`px-3 py-2 ${
                          location.pathname ===
                          "/units"
                            ? "bg-light fw-semibold"
                            : ""
                        }`}
                        style={{
                          cursor: "pointer",
                          fontSize: "14px",
                        }}
                        onClick={() => {
                          setFilterType("Units");
                          setShowFilter(false);
                          navigate("/units");
                        }}
                      >
                        Units
                      </div>

                    </div>
                  )}
                </div>

              </div>
            </div>

          </div>

        </div>
      </div>


      {/* =================================================
          MAIN CONTENT
      ================================================= */}

      <div className="row g-3 g-lg-4">

        {/* =================================================
            ALL CATEGORIES
        ================================================= */}

        <div className="col-12 col-lg-3">

          <div
            className="card border-0 shadow-sm h-100"
            style={{
              borderRadius: "18px",
            }}
          >

            <div className="card-body p-3">

              {/* CATEGORY HEADER */}
              <div className="d-flex align-items-center justify-content-between mb-3">

                <h5 className="fw-bold mb-0">
                  All Categories
                </h5>

                <span
                  className="badge rounded-pill px-3 py-2"
                  style={{
                    background:
                      "var(--primary-color)",
                  }}
                >
                  {categories.length}
                </span>

              </div>


              {/* CATEGORY LIST */}
              <div
                className="d-flex flex-column gap-2"
                style={{
                  maxHeight: "600px",
                  overflowY: "auto",
                }}
              >

                {categories.map((cat) => (
                  <button
                    key={cat.id}
                    type="button"
                    onClick={() => {

                      setSelectedCategory(
                        cat.cat_name
                      );

                      const filtered =
                        inventory.filter(
                          (item) =>
                            item.category ===
                            cat.cat_name
                        );

                      setFilteredItems(filtered);
                    }}
                    className="btn w-100 text-start fw-semibold d-flex align-items-center justify-content-between"
                    style={{
                      minHeight: "48px",
                      padding: "10px 14px",
                      borderRadius: "11px",

                      border:
                        selectedCategory ===
                        cat.cat_name
                          ? "1px solid var(--primary-color)"
                          : "1px solid #e5e7eb",

                      background:
                        selectedCategory ===
                        cat.cat_name
                          ? "var(--primary-color)"
                          : "#fff",

                      color:
                        selectedCategory ===
                        cat.cat_name
                          ? "#fff"
                          : "#333",

                      boxShadow:
                        selectedCategory ===
                        cat.cat_name
                          ? "0 4px 12px rgba(0,0,0,.10)"
                          : "none",
                    }}
                  >

                    <span className="text-truncate">
                      {cat.cat_name}
                    </span>

                    {selectedCategory ===
                      cat.cat_name && (
                      <span
                        className="flex-shrink-0 ms-2"
                        style={{
                          fontSize: "11px",
                        }}
                      >
                        ✓
                      </span>
                    )}

                  </button>
                ))}

                {categories.length === 0 && (
                  <div className="text-center text-muted py-4">
                    No Categories Found
                  </div>
                )}

              </div>

            </div>

          </div>

        </div>


        {/* =================================================
            ITEMS
        ================================================= */}

        <div className="col-12 col-lg-9">

          <div
            className="card border-0 shadow-sm h-100"
            style={{
              borderRadius: "18px",
              overflow: "hidden",
            }}
          >

            <div className="card-body p-3 p-md-4">

              {/* ITEMS HEADER */}
              <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">

                <div
                  className="min-width-0"
                  style={{
                    minWidth: 0,
                  }}
                >

                  <h5 className="fw-bold mb-1 text-truncate">
                    Category :{" "}
                    <span>
                      {selectedCategory ||
                        "No Category"}
                    </span>
                  </h5>

                  <small className="text-muted">
                    Items available in this category
                  </small>

                </div>


                {/* TOTAL ITEMS */}
                <span
                  className="badge rounded-pill px-3 py-2 flex-shrink-0"
                  style={{
                    background:
                      "var(--primary-color)",
                    fontSize: "12px",
                  }}
                >
                  Total Items :{" "}
                  {filteredItems.length}
                </span>

              </div>


              {/* =================================================
                  TABLE
              ================================================= */}

              <div className="table-responsive rounded-3 border">

                <table className="table table-hover align-middle text-center mb-0">

                  <thead>

                    <tr>

                      <th
                        className="text-white fw-semibold py-3 text-start ps-3"
                        style={{
                          background:
                            "var(--primary-color)",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Item Name
                      </th>

                      <th
                        className="text-white fw-semibold py-3"
                        style={{
                          background:
                            "var(--primary-color)",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Stock
                      </th>

                      <th
                        className="text-white fw-semibold py-3"
                        style={{
                          background:
                            "var(--primary-color)",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Total PP(₹)
                      </th>

                      <th
                        className="text-white fw-semibold py-3"
                        style={{
                          background:
                            "var(--primary-color)",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Total SP(₹)
                      </th>

                      <th
                        className="text-white fw-semibold py-3"
                        style={{
                          background:
                            "var(--primary-color)",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Sold
                      </th>

                    </tr>

                  </thead>


                  <tbody>

                    {filteredItems.length > 0 ? (

                      filteredItems.map(
                        (item, index) => (

                          <tr key={index}>

                            <td className="fw-semibold text-start ps-3">
                              {item.name}
                            </td>

                            <td>
                              {item.stock}
                            </td>

                            <td>
                              ₹{item.pur_price}
                            </td>

                            <td>
                              ₹{item.sale_price}
                            </td>

                            <td>
                              0
                            </td>

                          </tr>

                        )
                      )

                    ) : (

                      <tr>

                        <td
                          colSpan="5"
                          className="text-center py-5"
                        >
                          <div className="text-muted">
                            No Items Found
                          </div>
                        </td>

                      </tr>

                    )}

                  </tbody>


                  {/* =================================================
                      FOOTER
                  ================================================= */}

                  <tfoot>

                    <tr
                      style={{
                        background:
                          "var(--primary-color)",
                        color: "#fff",
                        fontWeight: "700",
                      }}
                    >

                      <td className="text-start ps-3">
                        Total
                      </td>

                      <td>
                        0
                      </td>

                      <td>
                        ₹0.00
                      </td>

                      <td>
                        ₹0.00
                      </td>

                      <td>
                        0
                      </td>

                    </tr>

                  </tfoot>

                </table>

              </div>

            </div>

          </div>

        </div>

      </div>


      {/* =================================================
          ADD CATEGORY MODAL
      ================================================= */}

      {showCategoryModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{
            background:
              "rgba(15,23,42,.60)",
            zIndex: 1055,
            backdropFilter: "blur(3px)",
          }}
        >

          <div className="modal-dialog modal-dialog-centered px-2 px-sm-3">

            <div
              className="modal-content border-0 shadow-lg overflow-hidden"
              style={{
                borderRadius: "22px",
                background: "#fff",
              }}
            >

              {/* MODAL HEADER */}
              <div
                className="px-3 px-sm-4 py-3"
                style={{
                  background: "#f8f9fc",
                  borderBottom:
                    "1px solid #eeeeee",
                }}
              >

                <div className="d-flex align-items-center justify-content-between">

                  <div className="d-flex align-items-center gap-3">

                    <div
                      className="d-flex align-items-center justify-content-center flex-shrink-0"
                      style={{
                        width: "44px",
                        height: "44px",
                        borderRadius: "13px",
                        background:
                          "var(--primary-color)",
                        color: "#fff",
                      }}
                    >
                      <FaPlus size={17} />
                    </div>

                    <div>

                      <h5 className="fw-bold mb-1">
                        Add Category
                      </h5>

                      <small className="text-muted">
                        Create a new category
                      </small>

                    </div>

                  </div>


                  {/* CLOSE */}
                  <button
                    type="button"
                    className="btn btn-light border-0 d-flex align-items-center justify-content-center flex-shrink-0"
                    style={{
                      width: "36px",
                      height: "36px",
                      borderRadius: "50%",
                      fontSize: "20px",
                      color: "#6c757d",
                    }}
                    onClick={() =>
                      setShowCategoryModal(
                        false
                      )
                    }
                  >
                    ×
                  </button>

                </div>

              </div>


              {/* MODAL BODY */}
              <div className="modal-body p-3 p-sm-4">

                <div className="mb-4">

                  <label className="form-label fw-semibold mb-2">
                    Category Name
                  </label>

                  <input
                    type="text"
                    className="form-control shadow-none"
                    placeholder="Enter Category Name"
                    value={categoryName}
                    onChange={(e) =>
                      setCategoryName(
                        e.target.value
                      )
                    }
                    style={{
                      height: "52px",
                      borderRadius: "12px",
                      background: "#f7f8fa",
                      border:
                        "1px solid #e2e5e9",
                    }}
                  />

                </div>


                {/* BUTTONS */}
                <div className="d-grid d-sm-flex justify-content-end gap-2">

                  <button
                    type="button"
                    className="btn btn-light border fw-semibold px-4"
                    style={{
                      minHeight: "46px",
                      borderRadius: "11px",
                    }}
                    onClick={() =>
                      setShowCategoryModal(
                        false
                      )
                    }
                  >
                    Cancel
                  </button>


                  <button
                    type="button"
                    className="btn text-white fw-semibold px-4"
                    style={{
                      minHeight: "46px",
                      borderRadius: "11px",
                      background:
                        "var(--primary-color)",
                    }}
                    onClick={
                      handleAddCategory
                    }
                    disabled={loading}
                  >
                    {loading
                      ? "Adding..."
                      : "Add"}
                  </button>

                </div>

              </div>

            </div>

          </div>

        </div>
      )}

    </div>
  );
};

export default Category;